import i18next from 'i18next';
import i18nextXHRBackend from 'i18next-xhr-backend';

export interface i18nProps {
  locale: string;
  baseUrl?: string;
}

const i18n = ({ locale, baseUrl = '' }: i18nProps) => {
  return i18next.use(i18nextXHRBackend).init({
    lng: locale,
    fallbackLng: 'en',
    keySeparator: '$',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${baseUrl}assets/locale/messages_{{lng}}.json`,
      crossDomain: true,
    },
  });
};

export default i18n;
